import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter } from 'react-router-dom';
import store from 'src/redux/store';
import { theme, GlobalStyle } from '@triumph/shared';
import App from './App';

const rootElement = document.getElementById('parts-finder');

const render = () => {
  const { basepath, contentDataSourceId } = rootElement.dataset;

  const root = createRoot(rootElement);

  root.render(
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <>
          <GlobalStyle />
          <BrowserRouter basename={basepath}>
            <App
              basepath={basepath}
              contentDataSourceId={contentDataSourceId}
            />
          </BrowserRouter>
        </>
      </ThemeProvider>
    </Provider>,
  );
};

render();
